
// store/indicatorSlice.js
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { BASE_URL } from '../commonConfig/ApiConfig';

// Fetch indicators with filters
export const fetchIndicators = createAsyncThunk(
  'indicator/fetchIndicators',
  async (filters, thunkAPI) => {
    try {
      const response = await axios.post(`${BASE_URL}indicators/filter`, filters);
      return response.data.indicators;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || 'Error fetching indicators');
    }
  }
);

// Fetch indicators for a specific sector by ID
export const fetchIndicatorById = createAsyncThunk(
  'indicator/fetchIndicatorById',
  async (id, thunkAPI) => {
    try {
      const res = await axios.get(`${BASE_URL}sectors/${id}/indicators`);
      return res.data;
    } catch (error) {
      console.error("Frontend API Error:", error);
      return thunkAPI.rejectWithValue(error.response?.data || 'Error fetching sector indicators');
    }
  }
);

const indicatorSlice = createSlice({
  name: 'indicator',
  initialState: {
    indicators: [],
    selectedSectorIndicators: [],
    loading: false,
    error: null,
  },
  reducers: {
    clearIndicators: (state) => {
      state.indicators = [];
    },
    clearSectorIndicators: (state) => {
      state.selectedSectorIndicators = [];
    },
  },
  extraReducers: (builder) => {
    builder
      // fetchIndicators
      .addCase(fetchIndicators.fulfilled, (state, action) => {
        state.loading = false;
        state.indicators = action.payload;
      })

      // fetchIndicatorById
      .addCase(fetchIndicatorById.fulfilled, (state, action) => {
        state.loading = false;
        state.selectedSectorIndicators = action.payload;
      })

      // Generic loading state
      .addMatcher(
        (action) => action.type.endsWith('/pending'),
        (state) => {
          state.loading = true;
          state.error = null;
        }
      )

      // Generic error handler
      .addMatcher(
        (action) => action.type.endsWith('/rejected'),
        (state, action) => {
          state.loading = false;
          state.error = action.payload || 'Something went wrong';
        }
      );
  },
});

export const { clearIndicators, clearSectorIndicators } = indicatorSlice.actions;
export default indicatorSlice.reducer;
